import { initContract } from '@ts-rest/core';
import { eventRoutes } from './events.contract';

const c = initContract();

export const adminEventsContract = c.router({
  getEvents: { ...eventRoutes.getEvents, path: '/admin/events' },
  getEventBySlug: { ...eventRoutes.getEventBySlug, path: '/admin/events/details/:slug' },
  getEventById: { ...eventRoutes.getEventById, path: '/admin/events/:event_id' },
  createEvent: { ...eventRoutes.createEvent, path: '/admin/events' },
  updateEvent: { ...eventRoutes.updateEvent, path: '/admin/events/:event_id' },
  incrementEventView: {
    ...eventRoutes.incrementEventView,
    path: '/admin/events/:event_id/increment-view',
  },
  deleteEvent: { ...eventRoutes.deleteEvent, path: '/admin/events/:event_id' },
});
